import axios from 'axios';
import moment from 'moment';
import { apiURLPrint } from 'global_config/constant-global';
import { logAuditTrailEvent } from 'services/system_setup/auditTrail';

const MODULE_CODE = 'inv';

function logInvoiceAction(action, description, payload, isSuccess = 1) {
	void logAuditTrailEvent({
		moduleCode: MODULE_CODE,
		subModuleCode: 'invoice',
		action,
		description,
		payload,
		isSuccess,
	});
}

function normalizeInvoiceTransactionAction(header = {}) {
	const submitValue = String((header && header.submit_val) || '').trim().toUpperCase();
	const statusValue = String((header && header.status) || '').trim().toUpperCase();

	if (submitValue === 'POST') return 'POST';
	if (submitValue === 'CANCEL') return 'CANCEL';
	if (statusValue === 'POSTED') return 'POST';
	if (statusValue === 'CANCELLED') return 'CANCEL';
	return 'SAVE';
}

function buildInvoiceAuditSnapshot(header = {}, details = []) {
	const drNumbers = Array.isArray(header && header.drNumber) ? header.drNumber : [];
	const deletedDrNumbers = Array.isArray(header && header.dr_delete_list) ? header.dr_delete_list : [];
	const submitValue = String((header && header.submit_val) || '').trim().toUpperCase();
	let targetStatus = 'NEW';

	if (submitValue === 'POST') targetStatus = 'POSTED';
	if (submitValue === 'CANCEL') targetStatus = 'CANCELLED';

	return {
		transaction_type: 'INVOICE',
		transaction_no: (header && (header.invoiceNumber || header.invoice_no)) || '',
		invoice_no: (header && (header.invoiceNumber || header.invoice_no)) || '',
		submit_val: (header && header.submit_val) || '',
		previous_status: (header && header.status) || '',
		target_status: targetStatus,
		customer_id: (header && header.customer_id) || null,
		total_amount_due: (header && header.totalAmountDue) || '',
		dr_count: drNumbers.length,
		dr_delete_count: deletedDrNumbers.length,
		detail_count: Array.isArray(details) ? details.length : 0,
	};
}

// search invoice api
export async function searchInvoiceAPI(payload) {
	
	if(payload.invoice_date !== undefined && payload.invoice_date !== null){
		if(Array.isArray(payload.invoice_date) && payload.invoice_date.length === 0){
			payload.invoice_date = undefined;
		}
	}

	const InvoiceNo = payload.invoice_no === undefined ? '' : payload.invoice_no;
	const Customer = payload.customer === undefined ? '' : payload.customer;
	const Agent = payload.agent === undefined ? '' : payload.agent;
	const FromDate = (payload.invoice_date === undefined || payload.invoice_date === null || !Array.isArray(payload.invoice_date) || payload.invoice_date.length === 0) 
		? '' : moment(payload.invoice_date[0]).format('MM-DD-YYYY');
	const ToDate = (payload.invoice_date === undefined || payload.invoice_date === null || !Array.isArray(payload.invoice_date) || payload.invoice_date.length === 0) 
		? '' : moment(payload.invoice_date[1]).format('MM-DD-YYYY');

	let invoicelist = [];

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}invoice/search/?invoice_no=${InvoiceNo}&customer=${Customer}&agent=${Agent}&start_date=${FromDate}&end_date=${ToDate}`,
			data: payload,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		invoicelist = data;
	} 
	catch(error) {
		logInvoiceAction('SEARCH', 'Invoice search failed', { request: payload, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}
	
	logInvoiceAction('SEARCH', 'Invoice search', { request: payload, resultCount: invoicelist.length }, 1);
	return invoicelist;
}

//create invoice api
export async function createInvoiceAPI(Header, Details) {
	let invoiceData = [];
	const action = normalizeInvoiceTransactionAction(Header);
	const snapshot = buildInvoiceAuditSnapshot(Header, Details);
	const transactionLabel = snapshot.invoice_no ? ` ${snapshot.invoice_no}` : '';
	
	// 🔍 DEBUG: Log exactly what's being sent to backend
	console.log('🌐 API-DEBUG: CREATE Invoice Request', {
		url: `${process.env.REACT_APP_BACKEND_API}invoice/create/`,
		header: Header,
		details: Details,
		drNumber: Header.drNumber,
		timestamp: new Date().toISOString()
	});
	
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}invoice/create/`,
			data: {Header, Details}
		}).then(response => {
			// 🔍 DEBUG: Log backend response
			console.log('🌐 API-DEBUG: CREATE Invoice Response', {
				status: response.status,
				data: response.data,
				headers: response.headers
			});
			return response;
		});
  
		// @ts-ignore
		invoiceData = axiosResponse;
	} 
	catch(error) {
		console.error('API-ERROR: CREATE Invoice Failed', error);
		logInvoiceAction(action, `${action} invoice${transactionLabel} failed`, { ...snapshot, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}
	logInvoiceAction(action, `${action} invoice${transactionLabel}`, snapshot, 1);
	return invoiceData;
}

//update invoice api
export async function updateInvoiceAPI(Header, Details) {
	let updateInvoice = [];
	const action = normalizeInvoiceTransactionAction(Header);
	const snapshot = buildInvoiceAuditSnapshot(Header, Details);
	const transactionLabel = snapshot.invoice_no ? ` ${snapshot.invoice_no}` : '';
	
	// 🔍 DEBUG: Log exactly what's being sent to backend
	console.log('🌐 API-DEBUG: UPDATE Invoice Request', {
		url: `${process.env.REACT_APP_BACKEND_API}invoice/update/`,
		header: Header,
		details: Details,
		drNumber: Header.drNumber,
		dr_delete_list: Header.dr_delete_list,
		timestamp: new Date().toISOString()
	});
	
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}invoice/update/`,
			data: {Header, Details}
		}).then(response => {
			// 🔍 DEBUG: Log backend response
			console.log('🌐 API-DEBUG: UPDATE Invoice Response', {
				status: response.status,
				data: response.data,
				headers: response.headers
			});
			return response;
		});
  
		// @ts-ignore
		updateInvoice = axiosResponse;
	} 
	catch(error) {
		console.error('API-ERROR: UPDATE Invoice Failed', error);
		logInvoiceAction(action, `${action} invoice${transactionLabel} failed`, { ...snapshot, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}
	logInvoiceAction(action, `${action} invoice${transactionLabel}`, snapshot, 1);
	return updateInvoice;
}

//customers details
export async function fetchCustomerDetailsAPI(customer_id) {
	let customersdetails = null;
	
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}invoice/customersdetails`,
			data: { customer_id },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		customersdetails = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return customersdetails;
}

//invoice details
export async function fetchInvoiceDetailsAPI(invoice_id) {
	let invoicedetails = [];
	
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}invoice/invoicedetails`,
			data: { invoice_id },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		invoicedetails = data;
	}
	catch(error) {
		logInvoiceAction('VIEW', 'View invoice details failed', { request: { invoice_id }, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}

	logInvoiceAction('VIEW', 'View invoice details', { request: { invoice_id } }, 1);
	return invoicedetails;
}

//DR list
export async function fetchDrListAPI() {
	let drlist = null;
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}invoice/drlist`,
			// data: {  },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		drlist = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return drlist;
}

//specific DR
export async function fetchSelectedDrAPI(drNum) {
	let drlist = null;
	
	// 🔍 DEBUG: Log DR fetch request
	console.log('🌐 API-DEBUG: Fetching Selected DRs', {
		drNum: drNum,
		url: `${process.env.REACT_APP_BACKEND_API}invoice/specificDr/${drNum}`,
		timestamp: new Date().toISOString()
	});
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}invoice/specificDr/${drNum}`,
			// data: {  },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		drlist = data;
		
		// 🔍 DEBUG: Log DR fetch response
		console.log('🌐 API-DEBUG: Selected DRs Response', {
			drNum: drNum,
			response: data,
			count: data ? data.length : 0
		});
	}
	catch(error) {
		console.error('🌐 API-ERROR: Failed to fetch selected DRs', error);
		throw error;
		// Message.error();
	}

	return drlist;
}

//invoice details
export async function fetchDrDetailsAPI(dr_id) {
	let drdetails = [];
	
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}invoice/drdetails`,
			data: { dr_id },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		drdetails = data;
	}
	catch(error) {
		logInvoiceAction('VIEW', 'View DR details failed', { request: { dr_id }, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}

	logInvoiceAction('VIEW', 'View DR details', { request: { dr_id } }, 1);
	return drdetails;
}

//invoice details
export async function fetchInvoiceDrAPI(invoice_id) {
	let invoicedr = [];
	
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}invoice/invoicedr`,
			data: { invoice_id },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		invoicedr = data;
	}
	catch(error) {
		logInvoiceAction('VIEW', 'View invoice DR links failed', { request: { invoice_id }, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}

	logInvoiceAction('VIEW', 'View invoice DR links', { request: { invoice_id } }, 1);
	return invoicedr;
}

//invoice header
export async function fetchInvoiceHeaderAPI(invoice_number) {
	let invoiceHeader = [];
	
	try{
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}invoice/invoicenumber`,
			data: { invoice_number },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		invoiceHeader = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return invoiceHeader;
}

//delete invoice details
export async function deleteInvDetailsAPI(invoice_line_id) {
	let delinvdetail = null;
	
	try{
		const response = await axios({
			method: 'DELETE',
			url: `${process.env.REACT_APP_BACKEND_API}invoice/delinvdetail`,
			data: { invoice_line_id },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		delinvdetail = data;
	}
	catch(error) {
		logInvoiceAction('DELETE', 'Delete invoice detail line failed', { request: { invoice_line_id }, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}

	logInvoiceAction('DELETE', 'Delete invoice detail line', { request: { invoice_line_id } }, 1);
	return delinvdetail;
}

export async function printInvoice(payload) {
	let details = null;	
	try{
		const response = await axios({
			method: 'POST',
			// url: `${apiURLPrint}grp_reports/generate.php`,
			//url: `https://grp.dxvista.com/reports/jrprintform/grp/invoice/PRT_INVOICE.jrxml`,
			url: `${process.env.REACT_APP_REPORTS_API}invoice/PRT_INVOICE.jrxml`,
			data: JSON.stringify(payload),
			headers: { 
			 	'Content-Type': 'application/json',
				'Access-Control-Allow-Origin':'*'
			}
		});

		const { data } = response;
		details = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}
	return details;
}

export async function printInvoicePreview(payload) {
	let details = null;	
	try{
		const response = await axios({
			method: 'POST',
			// url: `${apiURLPrint}grp_reports/generate.php`,
			//url: `https://grp.dxvista.com/reports/jrprintform/grp/invoice/PRT_INVOICE_PREVIEW.jrxml`,
			url: `${process.env.REACT_APP_REPORTS_API}invoice/PRT_INVOICE_PREVIEW.jrxml`,
			data: JSON.stringify(payload),
			headers: { 
			 	'Content-Type': 'application/json',
				'Access-Control-Allow-Origin':'*'
			}
		});

		const { data } = response;
		details = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}
	return details;
}

//create printed trxn
export async function invPrintedTrxnAPI(Data) {
	let result = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}printedtrxn/create/`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		result = axiosResponse;
	} 
	catch(error) {
		throw error;
	}
	
	return result;
}

export const invPrintexTrxnList = async () =>{
	let result = [];
	try {
		const axiosResponse = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}printedtrxn/list/`,
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		result = axiosResponse.data;

	} catch (error) {
		throw error;	
	}
	
	return result;
}

